<!-- <app-main-content></app-main-content> -->
<app-navbar *ngIf="!loading && loggedIn"></app-navbar>
<app-topbar *ngIf="!loading && loggedIn"></app-topbar>
<div *ngIf="!loading" [class.notloggedIn]="!loggedIn" class="layout-container">
    <router-outlet *ngIf="!loadingViewPage"></router-outlet>
</div>
<!-- <app-messages></app-messages> -->